const api_key = process.env.REACT_APP_HTTP_API_KEY;

// Funkcija za čitanje CSRF tokena iz cookie-ja
function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

export default function authHeader() {
  const csrftoken = getCookie('csrftoken');
  
  const headers = {
    "Api-key": api_key,
    "Content-Type": "application/json",
  };
  
  // Dodaj CSRF token ako postoji
  if (csrftoken) {
    headers["X-CSRFToken"] = csrftoken;
  }
  
  return headers;
}
